<h2 class="text-center" mat-dialog-title mat-dialog-draggable-title style="margin-bottom: 0px !important;">
  <span style="color: #09847b">{{'kyc.update_success_title' | translate}}</span>
<!--  <button type="button" class="close" aria-label="Close" (click)="onNoClick()">-->
<!--    <span aria-hidden="true">&times;</span>-->
<!--  </button>-->
</h2>
<mat-divider></mat-divider>
<div class="row">
  <div class="col-2 pr-0" style="text-align: center;padding-left: 0px !important; padding-top: 15px;">
    <img style="width: 100%" src="assets/images/kyc_success.png" alt="" />
  </div>
  <div class="col-10 pl-0">
    <div [innerHTML]="data.message | translate" style=" padding: 5px 7px 15px; font-size: medium; overflow-wrap: break-word;"></div>
  </div>
</div>


<div mat-dialog-actions class="justify-content-center">
  <button class="ml-2" mat-raised-button color="primary" [mat-dialog-close]="true">
    <span *ngIf="data.hashKey && data.tenantId">
      <em class="fa fa-list-ul"></em> {{'kyc.go_detail' | translate}}
    </span>
    <span *ngIf="!data.hashKey && !data.tenantId">
      <em class="fa fa-home fa-fw"></em> {{'kyc.go_home' | translate}}
    </span>
  </button>
</div>
